<template>
  <Dialog
    v-model:visible="showModalRef"
    :close-on-escape="store.getters.dialogsCloseOnEscape"
    :dismissableMask="store.getters.dialogsDismissableMask"
    :modal="store.getters.dialogsModal"
    class="user-has-groups-dialog large-dialog"
  >
    <template #header>
      Grupos del usuario
      <i
        class="custom-close-dialog-button cursor-pointer p-2 pi pi-times"
        @click="closeModal()"
      ></i>
    </template>

    <GroupsList
      :user="user"
      componentOrigin="user-has-groups"
      @add-group="emit('add-group')"
      @delete-group="emit('delete-group')"
    />
  </Dialog>
</template>

<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import Dialog from "primevue/dialog";

import GroupsList from "@/pages/_root/report-has-users-dialog/GroupsList.vue";

// #region Props, Emits
defineProps({
  user: {
    type: Object,
    required: true,
  },
});
const emit = defineEmits(["add-group", "delete-group"]);
// #endregion

// #region Params, Ref, Reactives, Computed
const store = useStore();
const showModalRef = ref(false);
// #endregion

// #region Functions
async function showModal() {
  showModalRef.value = true;
}

function closeModal() {
  showModalRef.value = false;
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
defineExpose({
  showModal,
});
// #endregion
</script>
